import * as React from 'react';
import Login from './components/account/Routes';

export const routes = <>{Login}</>;
